export default {
    // 服务器地址，用来登录跳转管理中心

    jumpGateway: 'https://www.luzhentong.com',
    // jumpGateway: 'http://39.91.139.180:18100',
    // jumpGateway: 'http://localhost:8092',
    jump: 'https://www.luzhentong.com/bw',
    // jump: 'http://39.91.139.180:18101',
    // jump: 'http://localhost:8091', // 公司电脑IP

    // wssUrl: 'ws://39.91.139.180:18100',
    wssUrl: 'wss://www.luzhentong.com',

    // 门户管理
    friendshipLinksList: 'portal/friendshipLinks/friendshipLinksList',
    bannerImg: 'portal/operatingPosition/operatingPositionList', //首页banner图
    friendlyLink: 'portal/friendshipLinks/friendshipLinksAll/', // 首页友情链接
    getMessageByType: 'portal/information/condition', // 首页政策指南
    detailNews: 'portal/information/', // 资讯详情
    helpCenter: 'portal/helpCentre/helpCentreList/', // 帮助中心
    questionnaire: 'portal/questionnaire/getList', // 调查问卷
    questionnaireById: 'portal/questionnaire', // 调查问卷详情根据id
    questionnaireSubmit: 'portal/searchResult', // 调查问卷详情提交
    aboutUs: 'portal/easyNewsAdm/easyNewsAdmList', // 关于我们
    infoMation: 'portal/platform', // 指导单位、承办单位等信息

    // 金融产品管理
    getEntryResult: 'product/applyProductManager/userByApply2', //首页最新成功案例
    findProduct: 'product/productManager/queryProduct/', //首页推荐产品
    // productByOrgIds: 'product/productManager/queryProductByOrgIds/', //金融机构详情-金融产品
    productByOrgIds: 'product/productManager/queryProductByOrgIdsAndChildren',
    queryListProductByOrgId: 'product/productManager/queryListProductByOrgId',
    financialPro: 'product/productManager/queryProduct/', //金融产品
    findNewProductById: 'product/productManager/', //金融产品详情
    queryProductByOrgNameUrl: 'product/productManager/queryProductByOrgName', //金融产品列表

    //金融服务管理
    serviceListByPage: 'service/financeServeProduct/condition',//分页查询金融服务列表
    serviceById: 'service/financeServeProduct/',//根据id查询服务
    getCounts: 'service/financeServeProduct/getCounts/',//根据机构id获取产品数量、成功对接数量

    // 融资需求管理
    getFinancingNeeds: 'demand/financingDemand/list', // 首页最新融资需求

    // 字典管理
    getProvinces: 'dic/region/regionAll', // 获取金融机构所有地区
    getAreas: 'dic/region/getAreas',
    dictionaryQuery: 'dic/dictionary/byCodes', // 字典
    helpDictionary: 'dic/dictionary/dictionaryList',

    // 机构管理 - uncheck
    queryOrgNum: 'business/businessOrg/orgNums', //根据机构类型查询机构数量
    queryOrgByOrgNameAndOrgType: 'business/businessOrg/queryOrgByOrgNameAndOrgType?',
    searchFinancialOrg: 'business/businessOrg/businessOrgList', // 获取金融机构
    financialOrgDetail: 'business/businessOrg/', // 金融机构详情
    // financialOrgDetailBranch: 'business/businessOrg/businessOrgList', // 金融机构详情子机构
    financialOrgDetailBranch: 'business/businessOrg/queryBusinessOrgChildrenList',
    // financialOrgDetailBranch: 'business/businessOrg/queryOrgByParentId/', // 金融机构详情子机构
    productOrgInfo: 'business/businessProductOrg/queryListByProductId', // 金融产品详情机构信息
    login: 'business/auth/login', // 首页四个登录
    apipath: 'business/verificationCode', // 获取验证码
    quitLogin: 'business/auth/loginOut', // 退出登录
    register: 'business/register', //注册账户
    forgetPassword: 'business/enterpriseUser/forgetPassword',//企业用户 - 登录页 - 忘记密码
    forgetPassWordOther: 'business/bankGovernmentUser/forgetPassword',//金融用户（金融、非银、其他） - 登录页 - 忘记密码

    // 机构管理 - check
    getUserInfo: 'user/auth/userInfo', // 获取用户信息
    modfiyPassword: 'user/enterpriseUser/changePassword',//企业用户 - 导航栏 - 修改密码
    modfiyPasswordOther: 'user/bankGovernmentUser/changePassword',//金融用户（金融、非银、其他） - 导航栏 - 修改密码

    // 日志管理
    statisticsData: 'log/portalStatistics', // 统计

    datarendering: 'log/portalStatistics',
    getUserAuthStatus: 'user/enterpriseUser',
    // 首页查询注册用户总数
    getAllCountUser: 'business/enterpriseUser/countUser',
    //企业登录（新的接口）
    enterpriseLoginUrl: 'business/auth/getUnifiedAuthURL',
    //拿到code后调用的接口
    useCodeLoginUrl: 'business/auth/unifiedLogin?code=',
    //注册接口
    registerUrl: 'business/auth/getUnifiedRegisterUrl',
    //登出
    logoutUrl: "user/auth/getUnifiedLogoutUrl",

    //首页新的政策支持
    newConditionUrl: 'portal/support/condition',
    newConditionDetailUrl: 'portal/support/',
    //政策支持四项统计
    getPolicySupportStatisticsUrl: "log/portalStatistics/getPolicySupportStatistics",
    // 政策支持里的申报日历
    getDeclareListUrl: 'portal/support/policyManagerCalendar',
    // 政策支持里的公示信息
    queryApplyInformationByPage: 'portal/policyApply/queryApplyInformationByPage',
    // 根据查询条件查询匹配的政策
    getMatchedPolicy: 'portal/support/mindRecommendation',
    // 政策支持里的匹配个人/企业信息
    getEnterpriseCombox: 'business/enterpriseUser/enterpriseCombox',
    //判断企业信息是否完善
    // checkEnterpriseInformation: "business/enterprise/checkEnterpriseInformation",
    checkEnterpriseInformation: "business/enterpriseUser",
    //获取放款笔数
    getPortalStatisticsList: "product/applyProductManager/getPortalStatisticsList?time=2021",
    //门户首页查询产品接口
    queryHomeProduct: "product/productManager/queryHomeProduct",

    //门户专栏互动交流培训视频查询数据
    training_video: "portal/interaction/querInteractionByPage",
    //门户专栏互动交流培训视频详情页数据
    training_videodatils: "portal/interaction",
    //门户专栏 信用体系建设-山东省农村信用主体创评状况表
    evaluationStatus: "log/creditSystem/ruralCredit",
    //门户专栏 信用体系建设-山东省涉农金融机构信用户让利情况统计
    orgCutProfit: "log/creditSystem/profitTransfer",
    //门户专栏 信用体系建设-山东省信用户信用贷款情况
    credituserLoan: "log/creditSystem/creditLoan",
    //门户专栏 信用体系建设-山东省各项贷款状况
    loanStatus: "log/creditSystem/variousLoans",
    //门户专栏 信用体系建设-财政一般预算支出
    budgetExpenditure: "log/creditSystem/budgetExpenditure",
    //门户专栏 信用体系建设-山东省各项存款状况
    variousDeposits: "log/creditSystem/variousDeposits",
    //门户专栏 信用体系建设-山东省一般财政预算收入状况
    budgetRevenue: "log/creditSystem/budgetRevenue",
    //门户专栏 信用体系建设-生产总值GDP
    grossDomesticproduct: "log/creditSystem/gdp",
    //门户专栏 信用体系建设-山东省农牧民人均可支配收入状况
    disposableIncome: "log/creditSystem/disposableIncome",
    //门户专栏 信用体系建设-山东省省级信用县分布
    creditCountymap: "log/creditSystem/creditCounty",
    //门户专栏-一网通和首贷中心 数据汇总
    dataTotal: "log/specialDataStatistics/statistics/dataTotal",
    //门户专栏-一网通 近｛month｝少月成交数据
    monthStatistics: "log/specialDataStatistics/statistics",
    //门户专栏-一网通 和首贷中心成功案例
    viaSuccessCase: "log/specialDataStatistics/statistics/success",
    //门户专栏-首贷中心周数据
    weekData: "log/specialDataStatistics/firstLoanCenter/weekData",
    //门户专栏-首贷中心产品
    productPage: "log/specialDataStatistics/firstLoanCenter/productPage",
    //门户专栏-首贷中心产品详情
    detailPageLoan: "log/specialDataStatistics/getFirstLoanCenterApplyDetailPage",
    //门户专栏-首贷中心区域排行
    rankArea: "log/specialDataStatistics/firstLoanCenter/ranking",

    fileDownLoad: "portal/files/downloadFile",

    loanAmountAndNum: 'product/applyProductManager/loanAmountAndNum/',


    // 企业
    getEnterprise: 'business/enterprise/',

    // 资产拍卖
    getZClist: 'portal/zichan/listHome',
    getCategory: 'portal/zichan/getCategory',
    getAreaData: 'dic/region/getAreaData',
    zichanList: 'portal/zichan/condition',
    getCurrentPrice: 'portal/paimai/getData/',
    getZiChanDetail: 'portal/zichan/',
    getChuJiaRecord: 'portal/paimai/chujiaList/',

    // 招投标
    zhaobiaoList: 'portal/zhaobiaoMgr/condition',
    getCurrentPrice2: 'portal/zhaobiaoMgr/getData/',
    getZiChanDetail2: 'portal/zhaobiaoMgr/',
    getChuJiaRecord2: 'portal/zhaobiaoMgr/chujiaList/',
    zhaobiaoBaoming: 'portal/zhaobiaoMgr/baoming2',
    zhaobiaoChujia: 'portal/zhaobiaoMgr/chujia',

    // 农资信息
    getNongZiList: 'portal/nongzi/condition',
    getNongZiDetail: 'portal/nongzi/',

    // 项目合作
    getXiangmuList: 'portal/xiangmu/condition',
    getXiangmuDetail: 'portal/xiangmu/',

    // 投资理财
    condition: 'portal/touzi/condition',
    getTouziInfo: 'portal/touzi',
    guanzhuAdd:'portal/guanzhu',
    guanzhuCancel:'portal/guanzhu/delete',

    // 农情提醒
    nqcondition:'portal/nongqing/condition',
    nqInfo:'portal/nongqing',

    // 服务推荐
    fwtjcondition:'portal/fuwu/condition',
    fwtjInfo:'portal/fuwu',

    getZxbd: 'portal/zichan/news2',
    baoming: 'portal/paimai/baoming2',
    chujia: 'portal/paimai/chujia',



    // 新版首页接口

    //新闻动态
    xwdtcondition: 'portal/information/condition',
    // 轮播图
    bannerList: 'portal/information/bannerList',

    // 统计
    tjInfo: 'log/portalStatistics/1/1',
    pmtjInfo: 'portal/zhaobiaoMgr/getStat',

}




// WEBPACK FOOTER //
// ./src/api/index.js